import {Component} from "react";

export class SellToWebTableRowComponent extends Component {
}
